/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_LecturersInputs */

const en__field_lecturers = /** @type {(inputs: _Field_LecturersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecturers`)
};

const de__field_lecturers = /** @type {(inputs: _Field_LecturersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dozenten`)
};

/**
* | output |
* | --- |
* | "Lecturers" |
*
* @param {_Field_LecturersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_lecturers = /** @type {((inputs?: _Field_LecturersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_LecturersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_lecturers(inputs)
	return de__field_lecturers(inputs)
});